import * as mailModuleOrchestrator from 'owa-mail-module-orchestrator';
import * as undoActions from 'owa-mail-undo';
import { ActionSource } from 'owa-mail-store';
import { lazyEndSearchSession, getScenarioStore, SearchScenarioId } from 'owa-search';
import { listViewStore } from 'owa-mail-list-store';

/**
 * Called after a node (Folder, Persona, Group) is selected in the folder forest
 */
export default async function onAfterSelectingFolder(actionSource?: ActionSource) {
    undoActions.clearLastUndoableAction();
    listViewStore.rowInfoForVLV.clear();
    listViewStore.scrollTop = 0;

    /**
     * If user is in search session, it should be ended (disregarding usual
     * conditions we check when search box is blurred).
     */
    if (getScenarioStore(SearchScenarioId.Mail).searchSessionGuid) {
        const endSearchSession = await lazyEndSearchSession.import();
        endSearchSession(SearchScenarioId.Mail, actionSource);
    }

    mailModuleOrchestrator.lazyOnSelectingFolder.importAndExecute();
}
